import { defineRoute } from '@kestrel/router';

import { ROUTE_PATHS } from './route-paths.js';

/*                                                                                          */
/*                 */
const isDevelopment = import.meta.env.MODE === 'development';

export const routes = [
    defineRoute({
        path: ROUTE_PATHS.HEALTH,
        methods: () => import('./views/health/+health.server.js'),
    }),
    defineRoute({
        path: ROUTE_PATHS.METRICS,
        methods: () => import('./views/metrics/+metrics.server.js'),
    }),
    defineRoute({
        path: ROUTE_PATHS.DESCRIPTION,
        template: () => import('./views/description/template.html?raw'),
        component: () => import('./views/description/+page.svelte'),
        server: () => import('./views/description/+page.server.js'),
    }),
    isDevelopment
        ? defineRoute({
              path: ROUTE_PATHS.DEMO,
              template: () => import('./demo/template.html?raw'),
              component: () => import('./demo/preview.svelte'),
              server: () => import('./demo/+page.server.js'),
          })
        : undefined,
].filter(Boolean);
